module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.9882/images/glasses-colourful-scarf/glasses-colourful-scarf@2x.png"